<div class="card bg_bonegrad" style="border-color:var(--welarasand) !important">
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <div class="row mt-1 mb-2">
          <div class="col-12">
            <div class="row mb-2 d-none">
              <div class="col-12 col-md-2">
                <label class="c_blue mt-1"><i class="fas fa-fw fa-user me-2"></i>Employee</label>
                <i class="fas fa-fw fa-lg fa-info-circle c_orange callout ms-2"
                   title="To use the system as a delegate user, use the View As selector at the top right of the screen"></i>
              </div>
              <div class="col-12 col-md-7">
                <select id="sel_employee"
                        class="form-select form-select-sm"
                        [(ngModel)]="entryForm.employeeID"
                        (change)="getEmployeeTasks()"
                        [disabled]="true">
                  <option value="">-- Choose Employee --</option>
                  <option *ngFor="let employee of listEmployees; trackBy: trackByFn" [value]="employee.id">{{ employee.f_name }} {{ employee.l_name }}</option>
                </select>
              </div>
              <div class="col-12 col-md-3">
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12 col-md-2">
                <label class="c_black bolder mt-2"><i class="fas fa-fw fa-tag me-2"></i>Entry Type</label>
              </div>
              <div class="col-12 col-md-7">
                <select id="sel_entrytype" class="form-select form-select-sm"
                        [(ngModel)]="entryForm.entryTypeID"
                        [disabled]="entryForm.isReadOnly">
                  <option value="">-- Choose Entry Type --</option>
                  <option *ngFor="let type of listTimeTypes; trackBy: trackByFn" [value]="type.id">{{ type.log_type }}</option>
                </select>
              </div>
              <div class="col-12 col-md-3">

              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12 col-md-2">
                <label class="c_black bolder mt-2"><i class="fas fa-fw fa-check me-2"></i>Task</label>
              </div>
              <div class="col-12 col-md-7">
                <ng-multiselect-dropdown [placeholder]="'Select Task'"
                                         [settings]="ddSettingsTask"
                                         [data]="listTasks"
                                         [(ngModel)]="entryForm.taskObject"
                                         (onSelect)="onTaskSelect($event)"
                                         style="width:500px">
                </ng-multiselect-dropdown>
              </div>
              <div class="col-12 col-md-3 mt-1">
                <input type="checkbox" id="cb_billable" [(ngModel)]="entryForm.entryBillable" [disabled]="entryForm.isReadOnly" value="" class="me-2" />
                <label for="cb_billable" class="c_blue"><b>Billable</b></label>
                <button *ngIf="showAddTaskButton" class="btn btn-sm btn-light ms-3 py-1 px-2" (click)="addTask()" title="Add Task">
                  <i class="fas fa-fw fa-plus me-1"></i>Add Task
                </button>
              </div>
            </div>

            <div class="row mb-2" style="min-height:28px" *ngIf="(entryForm.taskID != '')">
              <div class="col-12 col-md-2">
                <label class="c_blue"><i class="fas fa-fw fa-users me-2 mt-2"></i>Enter For</label>
                <i class="fas fa-fw fa-lg fa-info-circle c_orange ms-2" title="Admin Feature: Create time entries for other people assigned to the task."></i><br />
                
              </div>
              <div class="col-12 col-md-7 pt-1">
                <span *ngFor="let assignee of entryForm.entryAssignees; trackBy:trackByFn; let i = index" class="me-2" style="white-space:preserve nowrap">
                  <input type="checkbox" id="cbassignee_{{entryForm.entryAssignees[i].trim()}}"
                         [value]="assignee"
                         [disabled]="entryForm.isReadOnly"
                         class="me-2 mb-2 cbassignee"
                         [class.d-none]="(authAdmin == 0 && !(entryForm.entryAssignees[i].trim() == userID))" />
                  <label for="cbassignee_{{entryForm.entryAssignees[i].trim()}}"
                         style="width:75px"
                         [class.d-none]="(authAdmin == 0 && !(entryForm.entryAssignees[i].trim() == userID))">{{entryForm.entryAssigneeNames[i]}}</label>
                </span>
              </div>
              <div class="col-12 col-md-3">
                <input type="checkbox" [(ngModel)]="flagAllAssigned" (click)="toggleAllAssigned()" id="cb_allassigned" />
                <label for="cb_allassigned" class="ms-2 c_blue"><b>Select All</b></label>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12 col-md-2">
                <label class="c_black bolder mt-2" id="lbl_timeentrymode"><i class="fas fa-fw fa-clock me-2"></i>Time Entry Info</label>
              </div>
              <div class="col-12 col-md-10">
                <table class="table table-sm mb-0">
                  <tbody>
                    <tr>
                      <td class="p-0 pe-1" style="width:125px !important">
                        <input type="date"
                               #dt_task
                               [(ngModel)]="entryForm.entryDt"
                               class="form-control form-control-sm"
                               (change)="onDateChanged()"
                               (blur)="calculateDuration()"
                               (focus)="showCalendar()"
                               [disabled]="entryForm.isReadOnly"
                               [min]="entryForm.entryMinDt"
                               [max]="entryForm.entryMaxDt" />

                      </td>
                      <td class="p-0 pe-1" style="width:100px">
                        <input type="time" step="300" id="start_entry"
                               [disabled]="entryForm.isReadOnly"
                               [(ngModel)]="entryForm.entryStart"
                               class="form-control form-control-sm" />
                      </td>
                      <td class="p-0 py-1 ps-2" style="width:100px">
                        <label class="c_black bolder mt-1">Duration (h:m)</label>
                      </td>
                      <td class="p-0 pe-1" style="width:70px">
                        <input type="number" min="0" max="24" id="end_entry_duration"
                               [disabled]="entryForm.isReadOnly"
                               [(ngModel)]="entryForm.entryDurationHrs" class="form-control form-control-sm" placeholder="h" />
                      </td>
                      <td class="p-0 pe-1" style="width:70px">
                        <input type="number" min="0" max="60" id="end_entry_duration"
                               [disabled]="entryForm.isReadOnly"
                               [(ngModel)]="entryForm.entryDurationMins" class="form-control form-control-sm" placeholder="m" />
                      </td>
                      <td class="pt-2 ps-1" style="width:250px">
                        <input type="checkbox" [(ngModel)]="showDupeRow" id="cbDuplicate" class="me-2 d-none" />
                        <label for="cbDuplicate" class="d-none">Repeating Entry</label>

                        <select class="form-select form-select-sm d-none"
                                [disabled]="entryForm.isReadOnly"
                                [(ngModel)]="entryForm.entryTimeZone">
                          <option value="MST">Mountain Time (Denver)</option>
                          <option value="EST">Eastern Time (New York)</option>
                          <option value="GMT">Greenwich Mean Time (London)</option>
                          <option value="CET">Central Eurpoean Time (Geneva)</option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row mb-2" *ngIf="showDupeRow">
              <div class="col-12 col-md-2">
                <label class="c_black bolder mt-2" id="lbl_timeentrydupe"><i class="fas fa-fw fa-copy me-2"></i>Repeat For</label>
              </div>
              <div class="col-12 col-md-10">
                <span *ngFor="let weekDay of listWeekDays" class="me-2">
                  <input type="checkbox" id="repeat_{{weekDay.dayLabel}}" [value]="weekDay.dayLabel" class="me-2" />
                  <label for="repeat_{{weekDay.dayLabel}}">{{weekDay.dayLabel}}</label>

                </span>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12 col-md-2">
                <label class="c_black bolder mt-2"><i class="fas fa-fw fa-edit me-2"></i>Notes</label>
              </div>
              <div class="col-12 col-md-7">
                <textarea class="form-control form-control-sm" id="ta_notes"
                          [disabled]="entryForm.isReadOnly"
                          [(ngModel)]="entryForm.entryNotes" rows="2"></textarea>
              </div>
              <div class="col-12 col-md-3"></div>
            </div>
            <div class="row my-3" [hidden]="(errorMessage === '')">
              <div class="col-12 col-md-2">
              </div>
              <div class="col-12 col-md-7">
                <div class="alert alert-danger text-center p-1 mb-0">
                  <i class="fas fa-fw fa-info-circle me-1"></i>{{errorMessage}}
                </div>
              </div>
              <div class="col-12 col-md-3">
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <button class="btn btn-sm btn-dark me-1" title="Save Entry"
                        (click)="saveEntry()"
                        [disabled]="entryForm.isReadOnly">
                  <i class="fas fa-fw fa-save me-1"></i>Save Entry
                </button>
                <button class="btn btn-sm btn-light" title="Clear Entry"
                        (click)="resetEntry()">
                  <i class="fas fa-fw fa-arrow-rotate-left me-1"></i>Clear Entry
                </button>
                <span class="mx-3 c_blue"><strong [className]="(saveMode == 'admin lock') ? 'c_red' : 'c_blue'">{{saveMode.toUpperCase()}} MODE</strong></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
